import hasDom from 'has-dom';
export default function goToWalletCentral(walletStorageService) {
  return () => async dispatch => {
    if (hasDom() && walletStorageService) {
      walletStorageService.goToWalletCentral();
    }
  };
}